import * as ENV from '../util/env';
import Link     from '../components/link';
import React    from 'react';

const APPSTORE_URL  = 'https://itunes.apple.com/us/app/broadly-engage/id1234387781';
const PLAYSTORE_URL = 'https://play.google.com/store/apps/details?id=com.broadly.app';

export function shouldOpenInApp() {
  return ENV.isPuppeteer() || (ENV.isWeb() && hasAvailableApp() && ENV.isProduction());
}


function hasAvailableApp() {
  return ENV.isAndroid() || ENV.isIOS();
}


// getOpenInAppURL returns a url that when opened in a mobile client
// will open the native app, if installed.
//
// They look like this: broadly:/business/123
//
// According to https://url.spec.whatwg.org/#url-representation, this is considered a
// non-special scheme, and the host won't be parsed as such.
//
// Node and Safari are an exception to this rule.
// Both of them parse the first part of the path as the host,
// turning the path into `/123` (in our case), instead of `/business/123`.
//
// As a workaround, only for a limited time, let's return an iOS compatible url when
// the target platform is iOS.
//
// NOTE: This behavior will be fixed, and this workaround should
// not be replicated across the app
//
function getOpenInAppURL() {
  const pathname = window.location.hash.slice(2);
  const url      = ENV.isIOS() ?
    `broadly:///${pathname}` :
    `broadly:/${pathname}`;

  return url;
}


export function ForceOpenInApp() {
  const url = getOpenInAppURL();
  // Redirect to broadly app url.
  window.location = url;

  return (
    <div className="page-content">
      <div className="login-screen-content block">
        <div className="login-screen-title"></div>
        <div className="force-app-download">
          <div>
            <div>
              <Link className="button" href={window.location.href} external>Open in App</Link>
            </div>

            <p>
              On your smartphone or tablet, download Broadly from the App Store or the Google Play Store.
            </p>

            <div className="float-left">
              <Link href={APPSTORE_URL} external>
                <img
                  alt="Download Broadly on the App Store"
                  width="160"
                  src="/images/badges/appstore.png"
                />
              </Link>
            </div>
            <div className="float-right">
              <Link href={PLAYSTORE_URL} external>
                <img
                  alt="Download Broadly on the Play Store"
                  width="160"
                  src="/images/badges/playstore.png"
                />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
